<template>
  <div class="login">
    <card title="Sign in">
      <template v-slot:actions>
        <transition name="fade" mode="out-in">
          <b-form @submit.prevent="login" v-if="!step2" key="email">
            <b-form-group id="input-group-1" label="Account:" label-for="input-1">
              <b-form-input
                id="input-1"
                name="email"
                v-model="form.email"
                type="email"
                required
                :class="{'is-invalid': error}"
              ></b-form-input>
              <div class="icon">
                <i class="fas fa-user-circle"></i>
              </div>
            </b-form-group>
            <hr class="my-4" />
            <b-button type="submit" :disabled="disable" variant="primary" class="mr-3">Next</b-button>
          </b-form>

          <b-form @submit.prevent="verify" v-else key="passcode">
            <b-form-group id="input-group-2" label="Your password:" label-for="input-2">
              <b-form-input
                type="text"
                id="input-2"
                name="password"
                v-model="form.password"
                required
                placeholder="Enter password"
                :class="{'is-invalid': error}"
              ></b-form-input>
              <div class="icon">
                <i class="fas fa-fingerprint"></i>
              </div>
            </b-form-group>
            <hr class="my-4" />
            <b-button type="submit" variant="primary" :disabled="disable" class="mr-3">Next</b-button>
            <a href @click.prevent="back">back</a>
          </b-form>
        </transition>
        <p class="text-danger mt-3">{{error}}</p>
      </template>
    </card>
  </div>
</template>

<script>
import Card from "./ui/Card";

const url = "/auth/v3b4/authenticate";

export default {
  name: "Login",
  components: {
    Card
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
        checked: []
      },
      step2: false,
      error: null,
      disable: false
    };
  },
  computed: {
    serviceId() {
      return this.$store.state.serviceId;
    }
  },
  methods: {
    async login() {
      this.error = null;
      this.disable = true;
      try {
        await this.axios.post(url, {
          login: this.form.email,
          redirect_uri: this.$route.query.continue
        });
        this.step2 = true;
        this.disable = false;
      } catch (e) {
        this.disable = false;
        //console.log(e);
        if (e.response && e.response.status === 500)
          this.$router.push({ name: "error" });
        this.error = e.response
          ? e.response.data.error.message
          : "Invalid email address";
      }
    },
    async verify() {
      this.error = null;
      this.disable = true;
      try {
        await this.axios.post(url, {
          login: this.form.email,
          password: this.form.password.trim()
        });

        if (this.$route.query.continue) {
          window.location.replace(
            decodeURIComponent(decodeURI(this.$route.query.continue))
          );
        } else {
          this.$router.go("myaccount");
        }
      } catch (e) {
        //console.log(e);
        this.disable = false;
        if (e.response && e.response.status === 500) {
          this.$router.push({ name: "error" });
          return;
        }
        this.error = e.response
          ? e.response.data.error.message
          : "An error has occured";
      }
    },
    back() {
      this.step2 = false;
      this.form.password = "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.login /deep/ .cust-card {
  .title {
    padding-left: 80px;
    &::after {
      left: 80px;
    }
  }
  div.card {
    width: 28rem;
    .action {
      padding: 20px 80px;
    }
  }
}
.login {
  div.card {
    .action {
      .form-group {
        position: relative;
        .icon {
          position: absolute;
          bottom: 2px;
          font-size: 24px;
          color: #3c3a3a;
          left: -38px;
        }
      }
    }
  }
}
</style>
